import { isEmpty } from '@/utils/resultsHelper';
import { relativeUrl, splitUrlArguments } from '@/constants/urls';

const initialState = {
  fullscreen: false,
  labels: true,
  oldLayout: '',
  layout: '',
  context: 'fair',
  actions: {
    name: null,
    category: null,
    code: null,
    url: null,
  },
  hasRibbon: true,
  ribbonIsVisible: true,
  tabs: [],
  title: '',
};

export const tabState = (name, url, tooltip, selected, { dropDownIcon, icon, order }) => ({
  selected,
  name,
  dropDownIcon,
  icon,
  order,
  url,
  tooltip,
});

export const layoutStateToLoad = ({ labels, ribbonIsVisible }) => (
  {
    ...initialState,
    labels: isEmpty(labels) ? initialState.labels : labels,
    ribbonIsVisible: isEmpty(ribbonIsVisible) ? initialState.ribbonIsVisible : ribbonIsVisible,
  }
);
export const layoutStateToSave = ({ layout }) => (
  {
    labels: layout.labels,
    ribbonIsVisible: layout.ribbonIsVisible,
  }
);

export const tabIcons = (icon, iconPrefix = 'fas fa-') => ({
  icon: `${iconPrefix}${icon.replace(/\s+/g, '-')}`,
  dropDownIcon: icon,
});

export const tabTemplate = (name, component, pathInfo = [], ribbon = null) => ({
  name,
  access: () => true,
  componentState: ({ url }) => ({ url }),
  pathInfo,
  Ribbon: ribbon,
  order: 10000,
  position: 'left',
  Component: component,
  className: `${name}-panel`,
  ...tabIcons('exclamation triangle'),
  close: {
    action: {},
    dispatcher: () => {},
  },
});

export const tabCloser = (name, action) => ({
  close: { action: { [name]: action }, dispatcher: (props) => props[name] },
});

export const categoryTab = (url, category = 'open', componentState = {}) => (
  { url, category, ...componentState }
);

export const categoryCodeTab = (url, code, category = 'open') => (
  categoryTab(url, category, { code: decodeURIComponent(code) })
);

export const tabComponentState = ({ componentState }, url, props) => (
  componentState({ args: splitUrlArguments(url), url, props })
);

export const tabConfig = ({
  name, position, order, componentState,
}, url, props) => ({
  title: props.intl?.formatMessage({ id: `tabs.${name}` }),
  type: 'react-component',
  component: 'fair',
  componentState: {
    idePosition: position,
    isDirty: false,
    order,
    tooltip: null,
    ...tabComponentState({ componentState }, relativeUrl(url), props),
  },
});

export default initialState;
